import { render, staticRenderFns } from "./Subventionsabrechnung.vue?vue&type=template&id=7b827fee&"
import script from "./Subventionsabrechnung.vue?vue&type=script&lang=js&"
export * from "./Subventionsabrechnung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports